<div class="d-flex w-100 h-100 flex-column align-items-center">
  <h3 class="font-weight-bold text-primary text-center">{{ 'common_feature_in_development' | translate }}</h3>
  <h2 class="font-weight-bold text-secondary text-center">{{ 'common_available_soon' | translate }}</h2>
</div>
